module.exports = __webpack_public_path__ + "img/HEBO Trailers logo.c9ec2d44.png";